import { Layout, ListTitle, MTools } from "@/components";
import { getNewsList, getMediaList, getAllNews } from "@/services/service";
import React, { Component } from "react";
import styles from "./index.less";
import { RouteComponentProps, withRouter } from "dva/router";

import BetterScroll from "@better-scroll/core";
import PullUp from "@better-scroll/pull-up";
import { IMedia } from "@/models/types/media";
import { createRef } from "react";
import classnames from "classnames";
import moment from 'moment';

interface NewsProps {}
interface NewsState {
  list: IMedia[];
  tabIndex: number;

  getNewsList: any[];
}
type newsPropsInfo = NewsProps & RouteComponentProps<{}>;

BetterScroll.use(PullUp);
class News extends Component<newsPropsInfo, NewsState> {
  indexRef: any;
  constructor(props: newsPropsInfo) {
    super(props);
    this.state = {
      list: [],
      tabIndex: 1,
      getNewsList: [],
    };
    this.indexRef = createRef();
  }

  componentDidMount() {
    const local = window.location.pathname.split("/");
    const Id = local.length ? local[local.length - 1] : null;
    if (Id == '1') {
      this.setState({
        tabIndex: 1
      })
      this.getNewsList();
    } else if(Id == '2') {
      this.setState({
        tabIndex: 2
      })
      this.getMediaList();
    } else {
      this.setState({
        tabIndex: 0
      })
      this.getAllList();
    }

  }


  getNewsList = async () => {
    const result = await getNewsList({
      columnType: "news",
      status: 1,
      type: '2',
    });
    if (result.success) {
      result.data.map((item: any) => (item.title = item.name));

      this.setState({
        list: result.data.filter((item: any) => item.status == 1),
      });
    } else {
      MTools.Tips(
        "error",
        (result && result.message) || "系统异常，请刷新再试"
      );
    }
  };

  getMediaList = async () => {
    const result = await getMediaList({
      columnType: "theme",
      status: 1
    });
    if (result.success) {
      this.setState({
        list: result.data,
      });
    } else {
      MTools.Tips(
        "error",
        (result && result.message) || "系统异常，请刷新再试"
      );
    }
  };

  getAllList = async () => {
    const result = await getAllNews();
    if (result.success) {
      this.setState({
        list: (result.data || []).filter((i: any) => i.status === 1),
      });
    } else {
      MTools.Tips(
        "error",
        (result && result.message) || "系统异常，请刷新再试"
      );
    }
  }

  onTabs = (i: number) => {
    this.setState({
      tabIndex: i,
    });
    if (i == 1) {
      this.getNewsList();
    } else if (i == 2) {
      this.getMediaList();
    } else if (i == 0) {
      this.getAllList();
    }
  };

  handleGoToDetail = (item: any) => {
    const { tabIndex } = this.state;
    if (tabIndex === 1) { // 各地动态
      MTools.Url.gotoUrl(`/app/newsDetail/${item.id}?type=news`);
    } else if (tabIndex === 2) { // 热点资讯
      MTools.Url.gotoUrl(`/app/newsDetail/${item.id}?type=media`);
    } else if (item.type === 'news') { // 全部-各地动态
      MTools.Url.gotoUrl(`/app/newsDetail/${item.id}?type=news`);
    } else if (item.type === 'media') { // 全部-热点资讯
      MTools.Url.gotoUrl(`/app/newsDetail/${item.id}?type=media`);
    }
  }

  render() {
    const { list, tabIndex } = this.state;
    return (
      <div className={styles.index}>
        <Layout padding={23}>
          <div className={styles.wrapper}>
            <div className={styles.wrap_header}>
              <div
                className={classnames(
                  styles.wrap_header_item,
                  tabIndex == 0 ? styles.active : null
                )}
                onClick={() => this.onTabs(0)}
              >
                全部
              </div>

              <div
                className={classnames(
                  styles.wrap_header_item,
                  tabIndex == 2 ? styles.active : null
                )}
                onClick={() => this.onTabs(2)}
              >
                热点资讯
              </div>

              <div
                className={classnames(
                  styles.wrap_header_item,
                  tabIndex == 1 ? styles.active : null
                )}
                onClick={() => this.onTabs(1)}
              >
                各地动态
              </div>
            </div>
            <ul className={styles.wrap_center}>
              {list.map((item, i) => {
                return (
                  <li
                    key={i}
                    onClick={() => this.handleGoToDetail(item)}
                  >
                    <div className={styles.title}>{item.title}</div>
                    <div className={styles.time}>{moment(item.gmtCreate).format('YYYY-M-D')}</div>
                  </li>
                );
              })}
            </ul>
            {/* <div className={styles.foolter}>点击加载更多</div> */}
          </div>
        </Layout>
      </div>
    );
  }
}

export default withRouter(News);
